export default __webpack_public_path__ + "static/media/Rectangle_blue_1.22b9c0ae.svg";